import { Sun, Moon } from "lucide-react";
import { useTheme } from "./ThemeProvider";

/**
 * OPLYX dark/light toggle. Place in user menu or top-right of AppShell.
 */
export function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label={isDark ? "Mudar para tema claro" : "Mudar para tema escuro"}
      className={`inline-flex items-center justify-center w-8 h-8 rounded-md border border-transparent hover:border-white/10 dark:hover:border-white/10 hover:bg-black/5 dark:hover:bg-white/5 transition-colors text-neutral-600 dark:text-neutral-300 ${className}`}
    >
      {isDark
        ? <Sun className="w-4 h-4" strokeWidth={1.5} />
        : <Moon className="w-4 h-4" strokeWidth={1.5} />}
    </button>
  );
}

export default ThemeToggle;
